export const subtitles = {
    "1": {
        "startTime": 7.04,
        "endTime": 12.723,
        "transcript": "Aren assaliqatallruyaaqlua-ll' assaliarturnaluta taqkuma.",
        "translation": "Oh my, I was going to make frybread so that we would have some when I was done."
    },
    "2": {
        "startTime": 12.913,
        "endTime": 15.525,
        "transcript": "Maancimaniartukut.",
        "translation": "Let's stay here for a while."
    },
    "3": {
        "startTime": 15.571,
        "endTime": 18.38,
        "transcript": "Ii-i upcaaqlua, yaa.",
        "translation": "Yes, I prepared, yes."
    },
    "4": {
        "startTime": 18.817,
        "endTime": 22.689,
        "transcript": "Yaa acaciciqua(?) yuurqerniartukut.",
        "translation": "Yes, I'll make (?) so we can drink something hot."
    },
    "5": {
        "startTime": 22.708,
        "endTime": 25.034,
        "transcript": "Iciw'-llu Kakianam ellami piyuasqellrukiiten?",
        "translation": "And, you know, Kakianaq wanted you to walk outside."
    },
    "6": {
        "startTime": 25.051,
        "endTime": 27.564,
        "transcript": "Ii-i aren anyuumiitua.",
        "translation": "Yes, oh my, I don't want to go out."
    },
    "7": {
        "startTime": 28.249,
        "endTime": 33.061,
        "transcript": "Wall'u-q' keggani patio-mi camek tangvalartuten?",
        "translation": "Or do you watch something out from the patio?"
    },
    "8": {
        "startTime": 33.125,
        "endTime": 34.323,
        "transcript": "Canguapiaraqluten.",
        "translation": "You soend leisurely time."
    },
    "9": {
        "startTime": 34.326,
        "endTime": 37.123,
        "transcript": "Tua-i-qaa tiiviimeciiqell'.",
        "translation": "It'll probably be broadcast on TV."
    },
    "10": {
        "startTime": 37.883,
        "endTime": 43.319,
        "transcript": "Iciw' au͡gna Waves-an qanellren mumigcetellruken.",
        "translation": "You know, you wanted your Waves of Wisdom recording to be translated?"
    },
    "11": {
        "startTime": 43.319,
        "endTime": 43.873,
        "transcript": "Qaa?",
        "translation": "Really?"
    },
    "12": {
        "startTime": 43.899,
        "endTime": 47.64,
        "transcript": "Mumigtekan-llu tua-i tauna video-q aturluku piluku.",
        "translation": "Then when it's translated, we will use it."
    },
    "13": {
        "startTime": 48.243,
        "endTime": 49.66,
        "transcript": "Kituulriaten im' Yugtun?",
        "translation": "What's your Yup'ik name again?"
    },
    "14": {
        "startTime": 49.686,
        "endTime": 53.2,
        "transcript": "Elena, oh Narull'aq.",
        "translation": "Elena, oh, Narull'aq."
    },
    "15": {
        "startTime": 54.101,
        "endTime": 63.99,
        "transcript": "Qanemcitqerkut kitak' qaillun akaar miktellerpeni atsanek iqvaryalallrat yuut.",
        "translation": "Now, please tell us stories about people would go to pick berries long ago when you were small."
    },
    "16": {
        "startTime": 64.812,
        "endTime": 72.621,
        "transcript": "Ii-i, iqvalallrulrianga wii nasaurlullraullemni Nalqiglimi maligarullua.",
        "translation": "Okay, I used to go berry picking when I was a little girls in Nalqigliq, going along with them."
    },
    "17": {
        "startTime": 73.571,
        "endTime": 78.097,
        "transcript": "Imumek kangiralegmek iciw' qaltarlua,",
        "translation": "I used a square five-gallon gas can as, you know, my berry container,"
    },
    "18": {
        "startTime": 78.214,
        "endTime": 81.26,
        "transcript": "Kangiralegnek piu͡rlulallruamta.",
        "translation": "Because we poor people use square gas cans."
    },
    "19": {
        "startTime": 81.608,
        "endTime": 84.902,
        "transcript": "Tua-i-ll' tauna muirluku ut'rulluku.",
        "translation": "Then I filled it full and brought it home."
    },
    "20": {
        "startTime": 84.95,
        "endTime": 91.83,
        "transcript": "Utercama-llu aanama akulluku tamalkuan yugnun nerevkaritekluku.",
        "translation": "Then when I went home, my mother made Yup'ik ice cream with all of it and fed it to people."
    },
    "21": {
        "startTime": 92.189,
        "endTime": 98.87,
        "transcript": "Tuaten tua-i iqavaraqluta, tau͡gaam au͡gna aptellren qaillun uksurpak keep-alallrat?",
        "translation": "We would pick berries like that, but did you just ask how they would be kept all winter?"
    },
    "22": {
        "startTime": 98.896,
        "endTime": 105.092,
        "transcript": "Ii-i qaillun qemagtelallruitki imumi kumlivingvailegmeng yuut?",
        "translation": "Yes, how did people store them before they had freezers?"
    },
    "23": {
        "startTime": 105.108,
        "endTime": 110.493,
        "transcript": "Wiinga-w' tanglallrulrianga... tamakut tang wii iqvallrat nallunritenrilkeka.",
        "translation": "I used to see... see, I don't know how they picked berries."
    },
    "24": {
        "startTime": 110.52,
        "endTime": 114.74,
        "transcript": "Puckami, elaturrametaqluteng.",
        "translation": "In barrels, they would be in the porch."
    },
    "25": {
        "startTime": 114.96,
        "endTime": 121.05,
        "transcript": "Iciw' elaturrami cat neqkaput-llu uitatullrulriit kumlanateng,",
        "translation": "You know, our food would be in the porch and they would be cold."
    },
    "26": {
        "startTime": 121.099,
        "endTime": 126.26,
        "transcript": "Elaturrami-w' tua-i tanglallrukeka atsauteput puckami muragmi.",
        "translation": "I used to see our store of berries in the porch in a wooden barrel."
    },
    "27": {
        "startTime": 127.034,
        "endTime": 133.9,
        "transcript": "Akutaqavci saalartangvailgan camek akuyucilallruceci?",
        "translation": "When you made Yup'ik ice cream, before there was shortening, what type of fat would you use?"
    },
    "28": {
        "startTime": 133.904,
        "endTime": 140.01,
        "transcript": "Aanaka akutelallruuq tunurnek iciw' imkut, tallow, tunut,",
        "translation": "My mother used to make Yup'ik ice cream out of tunut, you know, tallow, tunut."
    },
    "29": {
        "startTime": 141.1,
        "endTime": 145.09,
        "transcript": "Reindeer-at tunuit.",
        "translation": "Reindeer tallow."
    },
    "30": {
        "startTime": 146.043,
        "endTime": 154.969,
        "transcript": "Kinercirluki tua-i-ll' kinercirraarluki akuteqatarqami uklicuayaarturluki assaalissuutmun ekluki,",
        "translation": "She dried them, then after drying them, when she was going to make Yup'ik ice cream, she would them into a frying pan,"
    },
    "31": {
        "startTime": 155.13,
        "endTime": 158.9,
        "transcript": "Tua-i-ll' maniluki kaminiamun, iciw' bacon-aatun.",
        "translation": "Then she would heat them on the stove, you know, like bacon."
    },
    "32": {
        "startTime": 160.007,
        "endTime": 166.281,
        "transcript": "Tua-i-ll' qallangluteng tzz-aarluteng tua-i-ll' mer'urrluni.",
        "translation": "Then they would boil, sizzing, then it would render."
    },
    "33": {
        "startTime": 166.691,
        "endTime": 170.18,
        "transcript": "Tamakut-llu qerrluteng ukliqcaarallri.",
        "translation": "And those pieces she cut up would bunch."
    },
    "34": {
        "startTime": 170.18,
        "endTime": 175.05,
        "transcript": "Tua-i-ll' taumek taggluku tamakut iciw' ciurluki waten.",
        "translation": "Then she removed them and, you know, wrung them like this."
    },
    "35": {
        "startTime": 175.41,
        "endTime": 185.478,
        "transcript": "Anlluki tauna-llu tua-i tunuq, iciw' bacon-aat urugarcilalriit uqumek?",
        "translation": "She took them out, then that tallow, you know how bacon renders grease?"
    },
    "36": {
        "startTime": 186.121,
        "endTime": 191.99,
        "transcript": "Uqupiamek add up-aarluku iciw' uqupiaq tunuq.",
        "translation": "She would add the fat, you know, the real fat, tallow."
    },
    "37": {
        "startTime": 192.674,
        "endTime": 198.85,
        "transcript": "Qanikcarciluteng iciw' qancikcaq imna kavtayagaq.",
        "translation": "They would get snow, you know, that snow, little hailstones."
    },
    "38": {
        "startTime": 200.214,
        "endTime": 206.848,
        "transcript": "Tamakucimek. Tua-i-ll' akulluni iciw' tuaken qanikcamek avuqaqluku.",
        "translation": "That kind. Then she would make Yup'ik ice cream, you know, periodically adding in that snow."
    },
    "39": {
        "startTime": 207.144,
        "endTime": 211.765,
        "transcript": "Akutaqami-ll'-am nepliqaunrit'laqiikut. Ciin-kiq?",
        "translation": "And when she made Yup'ik ice cream, she would tell us not to make any sound. I wonder why?"
    },
    "40": {
        "startTime": 212.019,
        "endTime": 214.041,
        "transcript": "Nepaunata uitaurnaurtukut.",
        "translation": "We would stay quietly."
    },
    "41": {
        "startTime": 214.46,
        "endTime": 219.182,
        "transcript": "Tua-i tuaten akutaqluni. Qaillun-wa tua-i elli'irqan qivilartau?",
        "translation": "That's how she made Yup'ik ice cream. I'm not sure at what stage she would add berries."
    },
    "42": {
        "startTime": 219.881,
        "endTime": 223.033,
        "transcript": "Tua-i tuaten tanglallruaqa tauna.",
        "translation": "That's how I used to see that."
    },
    "43": {
        "startTime": 223.041,
        "endTime": 229.323,
        "transcript": "Cali-qaa allatgun pilallruat? Uqurrlainarmek-qaa iliini ilaluk' pilallruat?",
        "translation": "What else did they use? Would they sometimes add oil/fat?"
    },
    "44": {
        "startTime": 230.984,
        "endTime": 237.73,
        "transcript": "Tua-i-w' tunurrlainaukuni tegpiarciqell'. Iciw' tunuq kumlangaqami teggpiatulria?",
        "translation": "Well, if it's all [solid] tallow, it would be very hard. You know how hard tallow gets when it's cold?"
    },
    "45": {
        "startTime": 237.73,
        "endTime": 242.49,
        "transcript": "Tua-i-ll' uqumek avuami mixed-arluni,",
        "translation": "Then when it's added and mixed with oil,"
    },
    "46": {
        "startTime": 244.087,
        "endTime": 249.93,
        "transcript": "Tua-i akucugngayugnarquq. Allamek tang nallulrianga.",
        "translation": "It can probably be whipped into Yup'ik ice cream. I don't know of any other."
    },
    "47": {
        "startTime": 249.946,
        "endTime": 255.03,
        "transcript": "Nallunritan-qaa qangvaq saalamek atulangellrat?",
        "translation": "Do you know when they started using shortening?"
    },
    "48": {
        "startTime": 255.03,
        "endTime": 261.24,
        "transcript": "Aren wii nallunritaqa. Ukaqvaggun.",
        "translation": "Oh my, I do know. It was recent."
    },
    "49": {
        "startTime": 261.911,
        "endTime": 264.846,
        "transcript": "Nunapicuarmi wiinga yuungnaqlua.",
        "translation": "I was making my own living in Nunapitchuk."
    },
    "50": {
        "startTime": 265.859,
        "endTime": 273.13,
        "transcript": "Yuungnaqenglua tua-i. Tua-i-llu au͡gna uicungaqa, au͡gkumiungurtelleq, Iilgayaq, Bristol Bay.",
        "translation": "I tried to make my own living. Then my male cross cousin who moved over there, Iilgayaq, Bristol Bay."
    },
    "51": {
        "startTime": 273.769,
        "endTime": 278.238,
        "transcript": "Allanrullermini, akutaitnilua wii pilua.",
        "translation": "When he came as a guest, I said I had no Yup'ik ice cream."
    },
    "52": {
        "startTime": 278.708,
        "endTime": 283.452,
        "transcript": "Kaugamek akutetuunga uqumek add-up-aarluku wii.",
        "translation": "I make Yup'ik ice cream out of tallow, adding in oil."
    },
    "53": {
        "startTime": 283.795,
        "endTime": 286.851,
        "transcript": "Pitullruunga tua-i saalamek nalluulua.",
        "translation": "I used to do that without any knowledge of shortening."
    },
    "54": {
        "startTime": 287.154,
        "endTime": 293.07,
        "transcript": "Taum-llu tua-i angutem ayuqucirturlua waten pillemni, \"Akutailngua tang wii.\"",
        "translation": "Then that man instructed me when I said this, \"See, I don't have any Yup'ik ice cream.\""
    },
    "55": {
        "startTime": 293.85,
        "endTime": 298.02,
        "transcript": "Cukalua-gguq akucukuma saalamek atam piqerlii.",
        "translation": "He said that if I want quick Yup'ik ice cream to use shortening."
    },
    "56": {
        "startTime": 298.02,
        "endTime": 300.489,
        "transcript": "Tua-i-ll' saalauteka maniamku,",
        "translation": "Then when I took out my shortning"
    },
    "57": {
        "startTime": 300.489,
        "endTime": 303.918,
        "transcript": "Saalarrlainaq miiskaamun waten teguqaulluni",
        "translation": "He took nothing but shortning like this into a mixing bowl"
    },
    "58": {
        "startTime": 304.715,
        "endTime": 308.952,
        "transcript": "Akucesqelluku emiqaqluku.",
        "translation": "He told me to whip it into Yup'ik ice cream occassinally adding water."
    },
    "59": {
        "startTime": 309.77,
        "endTime": 313.251,
        "transcript": "Wesson-oil-anek-llam avuqaqluk' pituit.",
        "translation": "They also add in Wesson oil."
    },
    "60": {
        "startTime": 313.252,
        "endTime": 316.734,
        "transcript": "Wiinga-am milegmek piluk' pituaqa.",
        "translation": "I personally do it with milk."
    },
    "61": {
        "startTime": 316.9,
        "endTime": 318.9,
        "transcript": "Ii-i ayuqenrilngatuq maani nunani.",
        "translation": "Yes, it seems to be different in these lands."
    },
    "62": {
        "startTime": 318.92,
        "endTime": 321.79,
        "transcript": "Tua-i-ll' tuakenirnek waniw'",
        "translation": "Then ever since then"
    },
    "63": {
        "startTime": 321.821,
        "endTime": 328.412,
        "transcript": "Kaugamek tallow-mek atunqigtevkenii saalarrlainarmek.",
        "translation": "I never used kaugaq, tallow, but only shortning."
    },
    "64": {
        "startTime": 329.382,
        "endTime": 331.27,
        "transcript": "Cukpiaraqluni.",
        "translation": "It's really quick."
    },
    "65": {
        "startTime": 331.272,
        "endTime": 338.27,
        "transcript": "Allanek qaa qivilallruit waten anllernek wall'u-q' quagcinek?",
        "translation": "Would they add in anything else like this, like tall cottongrass tubers or sourdock?"
    },
    "66": {
        "startTime": 338.398,
        "endTime": 346.109,
        "transcript": "Ii-i, anllernek, quagcilek. Anllelek, anllerrlainaq,",
        "translation": "Yes, tall cottongrass tubers, one with sourdock. The one with nothing but tall cottongrass tubers,"
    },
    "67": {
        "startTime": 346.518,
        "endTime": 349.49,
        "transcript": "Kiingan-tua-i avuvkenaku wii tangtullruaqa,",
        "translation": "By itself, I used to see it with nothing else added."
    },
    "68": {
        "startTime": 349.49,
        "endTime": 355.05,
        "transcript": "Quagciq-llu cali una atsanek avuluku, mixed-arluku.",
        "translation": "And this sourdock, they would add in berries, mixing them."
    },
    "69": {
        "startTime": 355.12,
        "endTime": 360.324,
        "transcript": "Maani-qaa Mamterillrem avatiini wall' Kusquqviim iluani,",
        "translation": "Is it here around Bethel or on the Kuskokwim,"
    },
    "70": {
        "startTime": 360.364,
        "endTime": 363.852,
        "transcript": "Makut anlleret pilallruaci?",
        "translation": "Would you gather tall cottongrass tubers?"
    },
    "71": {
        "startTime": 364.564,
        "endTime": 370.01,
        "transcript": "Wiinga maani Kusquqvagmi nalluanka tau͡gaam Akulmi pamani Nunapicuaq.",
        "translation": "I don't know about them here on the Kuskokwim, but in the Akula region, inland in Nunapitchuk."
    },
    "72": {
        "startTime": 370.203,
        "endTime": 380.296,
        "transcript": "Tamaani anllernek anllercurvigluta-llu au͡g'umek iciw' tua-i tuani anlleret pituluteng.",
        "translation": "We had a place to gather tall cottongrass tubers over there, you know, there would be some there."
    },
    "73": {
        "startTime": 380.959,
        "endTime": 386.759,
        "transcript": "Im'u caulriit im' imkut anlleret epuit.",
        "translation": "Well, what were the tubers' plants again?"
    },
    "74": {
        "startTime": 388.335,
        "endTime": 397.022,
        "transcript": "Tamakutalget anllertangqetuut. Iitaq, iitalget.",
        "translation": "Places with those have those tubers. Tall cottongrass, places with tall cottongrass."
    },
    "75": {
        "startTime": 401.452,
        "endTime": 408.431,
        "transcript": "Nallunritan-qaa nunat ayuqenrilnguut allarrauluteng akutelallrat?",
        "translation": "Do you know how different villages have slightly different ways of making Yup'ik ice cream?"
    },
    "76": {
        "startTime": 408.907,
        "endTime": 413.16,
        "transcript": "Kuigpagmiut, wall' allamiut?",
        "translation": "People from the Yukon, or other places?"
    },
    "77": {
        "startTime": 413.16,
        "endTime": 421.39,
        "transcript": "Maybe. Wiinga nallunritua tuar tang qagkumiut, Yukon.",
        "translation": "Maybe. I know, I think it's people from up there on the Yukon."
    },
    "78": {
        "startTime": 421.838,
        "endTime": 427.569,
        "transcript": "Akucunqellriit aren ima tanem akutelalriit-llu kemegnek, iciw' kemget,",
        "translation": "They like to make Yup'ik ice cream, I mean, they also make Yup'ik ice cream with meat, you know, meat"
    },
    "79": {
        "startTime": 428.258,
        "endTime": 435.17,
        "transcript": "White fish meat, kenirrarluku tua-i-ll' enriqcaarluku, amiirluki,",
        "translation": "White fish meat, after cooking it, then deboning it, then taking off their skins"
    },
    "80": {
        "startTime": 436.322,
        "endTime": 440.024,
        "transcript": "Ciurluki-ll' tua-i, tua-i-ll' akulluta.",
        "translation": "Then wring them, then make Yup'ik ice cream."
    },
    "81": {
        "startTime": 440.024,
        "endTime": 442.806,
        "transcript": "Iciw' tuar tang qanikcaqluki.",
        "translation": "You know, it's like they use them as snow."
    },
    "82": {
        "startTime": 443.175,
        "endTime": 449.19,
        "transcript": "Tua-i-ll' una calalriit ima? Uleluni, uleluni,",
        "translation": "Then this, what does it do? It rises, rises."
    },
    "83": {
        "startTime": 449.359,
        "endTime": 452.447,
        "transcript": "Tua-i-ll' wii tamakut tayim' nalluanka.",
        "translation": "Well, I don't know those."
    },
    "84": {
        "startTime": 452.447,
        "endTime": 455.659,
        "transcript": "Tau͡gaam qagkumiut, Yukon,",
        "translation": "Except for the people up there, Yukon."
    },
    "85": {
        "startTime": 455.802,
        "endTime": 460.224,
        "transcript": "Ava-i-llam ukaqvaggun au͡g'um keleglua.",
        "translation": "Then recently, that person invited me to go eat."
    },
    "86": {
        "startTime": 460.406,
        "endTime": 467.26,
        "transcript": "Akutartullruunga kemlek iciw' whitefish-am kemganek avuluku. Pituut.",
        "translation": "I had Yup'ik ice cream with meat, you know, with whitefish meat added. They do that."
    },
    "87": {
        "startTime": 467.378,
        "endTime": 470.531,
        "transcript": "Qaill'-mi mak'at?",
        "translation": "But how do they make aged salmon egg ice cream?"
    },
    "88": {
        "startTime": 470.851,
        "endTime": 476.632,
        "transcript": "Ciungani-qaa miktellerpeni-qaa mak'ilallruut?",
        "translation": "In the past, did they made salmon egg ice cream when you were small?"
    },
    "89": {
        "startTime": 476.65,
        "endTime": 480.37,
        "transcript": "Mak'ilallruut Kusquqvagmiutarnek iciw' meluk.",
        "translation": "They made salmon egg ice cream with, you know, fish roe from the Kuskokwim."
    },
    "90": {
        "startTime": 480.514,
        "endTime": 483.461,
        "transcript": "Initukait iciw' half dry?",
        "translation": "You know they hang them to half dry?"
    },
    "91": {
        "startTime": 483.472,
        "endTime": 492.536,
        "transcript": "Tua-i-ll' caquluki. (Taryaqviit-qaa kiimeng?) Piciatun, dog salmon, piciatun meluut iniluki.",
        "translation": "Then they encase them. (Only king salmon?) Any kind, dog salmon, they would hang any kind of roe to dry."
    },
    "92": {
        "startTime": 492.679,
        "endTime": 498.265,
        "transcript": "Tua-i-llu meluutelilallruukuk aipaqa-llu aipaqa qimugtelilallrani.",
        "translation": "Then my spouse and I had a lot of fish roe when he had a lot of dogs."
    },
    "93": {
        "startTime": 498.62,
        "endTime": 504.48,
        "transcript": "Qimugtet-am tamakut neq'liaqamiki melugmek tuaken ilaluki kemget pitui.",
        "translation": "When he made food for the dogs, he would add in roe from there into the meat."
    },
    "94": {
        "startTime": 504.48,
        "endTime": 510.32,
        "transcript": "Tua-i-llu mak'iyugaqamta meluk tauna camna ilua.",
        "translation": "Then when we wanted to make salmon egg ice cream, the roe beneath inside."
    },
    "95": {
        "startTime": 510.462,
        "endTime": 512.739,
        "transcript": "Tua-i waten teguluni-llu.",
        "translation": "He would take some like this."
    },
    "96": {
        "startTime": 512.964,
        "endTime": 517.799,
        "transcript": "Ilait-am qanlartut, \"Just like cheese-gguq.\" Cheese-aaq-gguq tua-i.",
        "translation": "Some say, \"Just like cheese.\" They say they are cheese."
    },
    "97": {
        "startTime": 517.859,
        "endTime": 521.43,
        "transcript": "Kassat-gguq tua-i cheese-aaracetun ayuqluni.",
        "translation": "They say it's like Western cheese."
    },
    "98": {
        "startTime": 521.43,
        "endTime": 527.38,
        "transcript": "Tamana tua-i unailnguq teggenrilnguq mak'itullruat.",
        "translation": "They would make aged salmon egg ice cream out of that soft part that wasn't hard."
    },
    "99": {
        "startTime": 528.679,
        "endTime": 534.563,
        "transcript": "Tua-i-ll' cali maa-i whitefish meluk, mak'ituut. Aspiarluni.",
        "translation": "And now, they make fish egg ice cream out of whitefish roe. It's very good."
    },
    "100": {
        "startTime": 534.563,
        "endTime": 536.16,
        "transcript": "Nutaan tang tamana niiskeka.",
        "translation": "That's the first time I heard that."
    },
    "101": {
        "startTime": 536.16,
        "endTime": 540.287,
        "transcript": "Whitefish-aat-am meluit aspiaraqluni, iciw' passiluki.",
        "translation": "Whitefish roe is very good, you know, crushing them."
    },
    "102": {
        "startTime": 540.906,
        "endTime": 544.74,
        "transcript": "Tepengssagauteng. Tamakut atam imkurtut,",
        "translation": "They have no odor. Those [others] are, you see,"
    },
    "103": {
        "startTime": 544.96,
        "endTime": 550.874,
        "transcript": "Meluut Kusquqvagmiut tepengqertut iciw'.",
        "translation": "Roe from the Kuskokwim have an odor, you know?"
    },
    "104": {
        "startTime": 551.879,
        "endTime": 556.397,
        "transcript": "Tua-i-w' caluteng rich-arluteng.",
        "translation": "They are, you know, rich."
    },
    "105": {
        "startTime": 556.664,
        "endTime": 561.769,
        "transcript": "Makut white fish-aat tua-i aspiat meluit, passirraarluki tau͡gaam.",
        "translation": "These whitefish roe is very good, but after crushing them."
    },
    "106": {
        "startTime": 561.846,
        "endTime": 565.891,
        "transcript": "Tua-i-ll' imkut nuyarngalnguut iciw' au͡g'arluki.",
        "translation": "Then remove those things that look like hair."
    },
    "107": {
        "startTime": 566.061,
        "endTime": 570.392,
        "transcript": "Nuyarngalngengqetuut. Caqullrit-wa pillilriit meluut.",
        "translation": "They have things that look like hair. It's porbably the membrane from the roe."
    },
    "108": {
        "startTime": 570.501,
        "endTime": 573.177,
        "transcript": "Tamakunek-llu mak'ilallruut.",
        "translation": "They'd also make fish egg ice cream with those."
    },
    "109": {
        "startTime": 574.22,
        "endTime": 581.03,
        "transcript": "Quliranek-qaa nallunritqanrituten akaar akutat quliraitnek?",
        "translation": "Do you happen to know any legends from long ago about Yup'ik ice cream?"
    },
    "110": {
        "startTime": 581.06,
        "endTime": 587.18,
        "transcript": "Nalluunga. Iciw' wiinga qulirat nalluanka.",
        "translation": "I don't know. You know, I don't know legends."
    },
    "111": {
        "startTime": 587.422,
        "endTime": 590.811,
        "transcript": "Iciw' wii anglaniketaitellruunga.",
        "translation": "You know, I didn't find anything fun."
    },
    "112": {
        "startTime": 591.138,
        "endTime": 595.966,
        "transcript": "Ceńirtaanqurraama tua-i epsalngutarlua.",
        "translation": "Since I'm the one who visits others the most, I get suffocated easily."
    },
    "113": {
        "startTime": 596.14,
        "endTime": 599.681,
        "transcript": "Waniw' tua-i quliringuamek-llu nalluunga.",
        "translation": "Now, I don't know about any legends."
    },
    "114": {
        "startTime": 600.32,
        "endTime": 604.125,
        "transcript": "Qaillun akaar iqvaryalallruceci? Qayatgun-qaa?",
        "translation": "How did you go berry picking long ago? With kayaks?"
    },
    "115": {
        "startTime": 604.13,
        "endTime": 606.057,
        "transcript": "Angyatgun cavluta.",
        "translation": "We rowed boats."
    },
    "116": {
        "startTime": 606.057,
        "endTime": 611.864,
        "transcript": "Ataucirqumek Nalqiglimek cakma Naparyarrarmiut akiatni nunallret.",
        "translation": "One time from Nalqigliq downriver, at the old village sites across Napakiak."
    },
    "117": {
        "startTime": 611.924,
        "endTime": 614.651,
        "transcript": "Iciw' tayim' catairutut.",
        "translation": "You know, they're all gone now."
    },
    "118": {
        "startTime": 615.754,
        "endTime": 619.36,
        "transcript": "Au͡gna-llu friend-aqa-llu Kassiglurmiu-ll' tuqullruuq.",
        "translation": "And my friend from Kasigluk died."
    },
    "119": {
        "startTime": 619.36,
        "endTime": 621.18,
        "transcript": "Tinker-aam nulirra.",
        "translation": "Tinker's wife."
    },
    "120": {
        "startTime": 621.535,
        "endTime": 625.729,
        "transcript": "Tauna-ll' atam aipaqelgullruukuk tua-i maligarucunqegglunuk.",
        "translation": "She and I always played together, and liked to go with each other."
    },
    "121": {
        "startTime": 626.036,
        "endTime": 629.804,
        "transcript": "Maligutukuk-am Nunapicuarmun atsiyalrianun.",
        "translation": "We went along with those who went to pick berries in Nunapitchuk."
    },
    "122": {
        "startTime": 629.96,
        "endTime": 635.911,
        "transcript": "Cav'urlunuk iciw' waten, row.",
        "translation": "We kept rowed, you know, rowing like this."
    },
    "123": {
        "startTime": 636.81,
        "endTime": 638.35,
        "transcript": "Tua-i-w' cavluteng.",
        "translation": "Well, they rowed."
    },
    "124": {
        "startTime": 638.842,
        "endTime": 644.613,
        "transcript": "Cavluta tagluta Nunapicuarmun, yaaqsipiaq.",
        "translation": "We rowed up to Nunapitchuk, very far away."
    },
    "125": {
        "startTime": 644.62,
        "endTime": 645.978,
        "transcript": "Qavartalallruuci-qaa?",
        "translation": "Would you camp?"
    },
    "126": {
        "startTime": 646.008,
        "endTime": 650.008,
        "transcript": "Qavartaraqluta tau͡gaam, how many days.",
        "translation": "But we would camp, how many [several] days."
    },
    "127": {
        "startTime": 651.078,
        "endTime": 659.19,
        "transcript": "Tauna-ll' tua-i wangkuk friend-aqa-llu assigtapuk murilkurluraqluki iciw' iqvautepuk.",
        "translation": "Then my friend and I would watch over our containers, you know, the berries we picked."
    },
    "128": {
        "startTime": 659.235,
        "endTime": 663.903,
        "transcript": "Taukut-wa tua-i au͡gna five gallon-aarullilria-wa.",
        "translation": "Those, it was probably a five gallon bucket."
    },
    "129": {
        "startTime": 664.43,
        "endTime": 667.603,
        "transcript": "Tua-i taun' wii assigtaqtullrukeka.",
        "translation": "That's what I used for a container."
    },
    "130": {
        "startTime": 667.96,
        "endTime": 670.043,
        "transcript": "Inglua waten callalluni.",
        "translation": "The other had a hole in it."
    },
    "131": {
        "startTime": 670.2,
        "endTime": 673.44,
        "transcript": "Iciw' cavignek pitullrulriit im' kaassat.",
        "translation": "You know gas had metal [containers]?"
    },
    "132": {
        "startTime": 673.514,
        "endTime": 679.98,
        "transcript": "Caqurluteng, five gallon. Tamakuciq. Plastic-aanek nalluluta.",
        "translation": "They had [those] containers, five gallon. That kind. We didn't know of any plastic."
    },
    "133": {
        "startTime": 679.983,
        "endTime": 687.153,
        "transcript": "Qaill'-mi tan'gerpiit iqvarraarluki qemagtelallruceciki aturnatkavceńun?",
        "translation": "But after picking crowberries, how did you store them until you used them?"
    },
    "134": {
        "startTime": 687.992,
        "endTime": 690.952,
        "transcript": "Tanglallruunga imkunun,",
        "translation": "I would see them put into those things,"
    },
    "135": {
        "startTime": 690.952,
        "endTime": 693.519,
        "transcript": "Mukaarutlernun assigtarluki.",
        "translation": "They stored them in empty flour bags."
    },
    "136": {
        "startTime": 693.795,
        "endTime": 701.65,
        "transcript": "Tua-i-ll' mermun akurrluki. Iciw' tua-i cunaw' tang freezer-aurlurluki tua-i mermun.",
        "translation": "Then they submerged them in water. You know, they used the water like a freezer."
    },
    "137": {
        "startTime": 702.175,
        "endTime": 705.809,
        "transcript": "Tuani-wa kumlatellriami assirciqngata.",
        "translation": "It's because they would be good there where it's cold."
    },
    "138": {
        "startTime": 706.286,
        "endTime": 709.589,
        "transcript": "Nallunritaqa-ll' wangkuk pillruukuk aipaqa-llu.",
        "translation": "And I know, my husband and I did this."
    },
    "139": {
        "startTime": 709.589,
        "endTime": 713.843,
        "transcript": "Akimteńi ikani kit'elluku tauna mermun.",
        "translation": "We let that sink across from us in the water."
    },
    "140": {
        "startTime": 715.404,
        "endTime": 716.172,
        "transcript": "Kuigmun?",
        "translation": "Into the river?"
    },
    "141": {
        "startTime": 716.29,
        "endTime": 717.254,
        "transcript": "Kuigmun.",
        "translation": "Into the river."
    },
    "142": {
        "startTime": 717.334,
        "endTime": 719.5,
        "transcript": "Tau͡gaam kuikapiarauvkenani.",
        "translation": "But it was a major river."
    },
    "143": {
        "startTime": 719.5,
        "endTime": 726.63,
        "transcript": "Agaani camun tuar tang Nanvaryugyaq tumngurngilngurmun, angyat tumekngailkiitnun.",
        "translation": "Somewhere across there, I think it was in Nanvaryugyaq where it wasn't a path, where the boats wouldn't go through."
    },
    "144": {
        "startTime": 726.68,
        "endTime": 731.28,
        "transcript": "Nenglengan-llu tua-i-ll' mayurrluku, teguluku, assigtarluku.",
        "translation": "Then when it got cold, we raised it, took it, and put it in a container."
    },
    "145": {
        "startTime": 731.814,
        "endTime": 734.79,
        "transcript": "Surat-mi? Tuaten-llu-qaa surat pilallruat?",
        "translation": "What about blueberries? Would they do that with blueberries too?"
    },
    "146": {
        "startTime": 734.79,
        "endTime": 738.079,
        "transcript": "Curat-wa wiinga tang curautengqellrunrilngua.",
        "translation": "Blueberries, well, I didn't have any blueberries, you see."
    },
    "147": {
        "startTime": 738.079,
        "endTime": 741.781,
        "transcript": "Tau͡gaam egmian ner'tuluki curatetuyaaqukut.",
        "translation": "But we do get blueberries and eat them right away."
    },
    "148": {
        "startTime": 742.03,
        "endTime": 743.853,
        "transcript": "Egmian tau͡gaam ner'aqluki.",
        "translation": "We only ate them right away."
    },
    "149": {
        "startTime": 744.08,
        "endTime": 748.649,
        "transcript": "Piuteksuunaki, assiirrngiata-wa.",
        "translation": "We didn't do that with them because they spoil easily."
    },
    "150": {
        "startTime": 748.7,
        "endTime": 751.838,
        "transcript": "Kumlivigni tau͡gaam maa-i assiircuitut.",
        "translation": "But they don't spoil in freezers now."
    },
    "151": {
        "startTime": 753.66,
        "endTime": 760.56,
        "transcript": "Cali-q' allanek akutelallruut? Allanek?",
        "translation": "Would they make Yup'ik ice cream with anything else? Other things?"
    },
    "152": {
        "startTime": 760.897,
        "endTime": 765.888,
        "transcript": "Kavirlit? Kavirliit-llu qerpercilaqait.",
        "translation": "Cranberries? They also make crushed whitefish roe ice cream with cranberries."
    },
    "153": {
        "startTime": 765.926,
        "endTime": 768.12,
        "transcript": "Qerpertaq. Nallunritan?",
        "translation": "Whitefish roe ice cream. Do you know about it?"
    },
    "154": {
        "startTime": 768.12,
        "endTime": 769.884,
        "transcript": "Qaillun im' qerpercilalriit?",
        "translation": "How do they make it again?"
    },
    "155": {
        "startTime": 769.884,
        "endTime": 774.986,
        "transcript": "Qerpercilallruukut whitefish meluk, cali-am passiluku.",
        "translation": "We would make crushed whitefish roe ice cream out of whitefish roe, also crushing it."
    },
    "156": {
        "startTime": 775.02,
        "endTime": 778.585,
        "transcript": "Passirraarluku-ll' tua-i kavirliit iciw' cali-ll' passiluki.",
        "translation": "Then after crushing it, we would also crush, you know, the cranberries."
    },
    "157": {
        "startTime": 779.003,
        "endTime": 782.546,
        "transcript": "Passiurluki tua-i camek avuqangsaarpek'naku.",
        "translation": "We crushed them without adding anything."
    },
    "158": {
        "startTime": 782.729,
        "endTime": 787.28,
        "transcript": "Mak'aq tau͡gaam caliaqumanaqtuuq. Nallunritan?",
        "translation": "But salmon egg ice cream takes a lot of work. Do you know about it?"
    },
    "159": {
        "startTime": 789.161,
        "endTime": 794.09,
        "transcript": "Avani qerpertaugaqameng ima tanem yogurt-aacetun ayuqelalriit?",
        "translation": "When they were made into crushed whitefish roe ice cream back then, wouldn't they be like yogurt?"
    },
    "160": {
        "startTime": 794.09,
        "endTime": 797.889,
        "transcript": "Ii-i, qerpertaq-llu tua-i tauna camek avungssagaunaku.",
        "translation": "Yes, and they wouldn't add anything to that crushed roe ice cream."
    },
    "161": {
        "startTime": 797.915,
        "endTime": 802.531,
        "transcript": "Passiluku, passirraarluku-llam tua-i au͡gkut nuyarngalnguut au͡garraarluki.",
        "translation": "Crush it, then after crushing it, after taking out those things that look like hair"
    },
    "162": {
        "startTime": 802.531,
        "endTime": 805.805,
        "transcript": "Tua-i-ll' qivirluk' cali passiluki kavirlit.",
        "translation": "Then add berries and crush the cranberries."
    },
    "163": {
        "startTime": 806.024,
        "endTime": 809.96,
        "transcript": "Passiurarraarluku akulluku, saarraliraqluku.",
        "translation": "After crushing it, mix it, adding sugar."
    },
    "164": {
        "startTime": 809.96,
        "endTime": 813.086,
        "transcript": "Qerpertaq-qaa melugmek ilangqertuq?",
        "translation": "Does crushed roe ice cream have fish roe?"
    },
    "165": {
        "startTime": 813.09,
        "endTime": 818.04,
        "transcript": "Meluuguq. Qerpercituut melugnek, whitefish meluk.",
        "translation": "It is made of fish roe. They make crushed whitefish roe ice cream out of roe, whitefish roe."
    },
    "166": {
        "startTime": 818.111,
        "endTime": 821.873,
        "transcript": "Kiingan tua-i nallunritaqa, tamakunek kiingan qerpercituut.",
        "translation": "I only know that they only make crushed whitefish roe ice cream out of those."
    },
    "167": {
        "startTime": 822.283,
        "endTime": 828.926,
        "transcript": "Tua-i-ll' iciw' fluffy-rluni. Tua-i-ll' tuaten pian taqluku.",
        "translation": "Then, you know, it would be fluffy. Then when it became like that, they finished it."
    },
    "168": {
        "startTime": 829.05,
        "endTime": 832.764,
        "transcript": "Ner'aqluku tau͡gaam uqirluku, uqiqerluku.",
        "translation": "But they would eat it with seal oil, a little bit of seal oil."
    },
    "169": {
        "startTime": 833.064,
        "endTime": 836.786,
        "transcript": "Yaa, quyana qanemciqallerpenek.",
        "translation": "Well, thank you for your stories."
    },
    "170": {
        "startTime": 837.38,
        "endTime": 839.97,
        "transcript": "Taqsaqlirtukuk.",
        "translation": "We're finally done."
    },
    "171": {
        "startTime": 1029.96,
        "endTime": 1030.87,
        "transcript": "Tua-i.",
        "translation": "Stop."
    },
    "172": {
        "startTime": 1033.13,
        "endTime": 1035.28,
        "transcript": "Takaryugtua.",
        "translation": "I'm shy."
    },
    "173": {
        "startTime": 1037.61,
        "endTime": 1040.14,
        "transcript": "Maaken-qaa makut tan'gerpiit iqvalqaci?",
        "translation": "Did you pick these crowberries from here?"
    },
    "174": {
        "startTime": 1040.14,
        "endTime": 1045.55,
        "transcript": "Yaa, maani last year iqvallratni.",
        "translation": "Yes, when they picked berries here last year."
    },
    "175": {
        "startTime": 1046.75,
        "endTime": 1051.92,
        "transcript": "[?Neqautellruanga]-am tuar two five gallons nangluki.",
        "translation": "[?(S)he gave me food], I think two five gallons, all of them."
    },
    "176": {
        "startTime": 1051.92,
        "endTime": 1058.51,
        "transcript": "Iqvaryunqeggami aipaagni piviirucami taitelallrui.",
        "translation": "Because she loves to pick berries, she would bring them probably because she had no more room."
    },
    "177": {
        "startTime": 1058.51,
        "endTime": 1062.33,
        "transcript": "[?]aryunqepiartuq mom-an.",
        "translation": "Your mom loves to [?]."
    },
    "178": {
        "startTime": 1062.715,
        "endTime": 1069.69,
        "transcript": "Nasaurluullrani-llu-qaa tuaten malikluci ayalallruuci? (Ii-i.)",
        "translation": "When she was a girl, would go travel together like that? (Yes.)"
    },
    "179": {
        "startTime": 1069.695,
        "endTime": 1073.52,
        "transcript": "Tuaten nutem ayuquq [?].",
        "translation": "That's what [?] has always been like."
    },
    "180": {
        "startTime": 1073.52,
        "endTime": 1077.55,
        "transcript": "Ca tamalkuan iciw' anglanakaa.",
        "translation": "She finds everything, you know, enjoyable."
    },
    "181": {
        "startTime": 1077.92,
        "endTime": 1079.3,
        "transcript": "Ava-i-llam Fairbanks...",
        "translation": "And recently, in Fairbanks..."
    },
    "182": {
        "startTime": 1079.305,
        "endTime": 1082.085,
        "transcript": "Kass'atun-kiq im'uryugngalliuq?",
        "translation": "I wonder if she can do it in English?"
    },
    "183": {
        "startTime": 1084.7,
        "endTime": 1089.84,
        "transcript": "Kass'at niicugnirkaatnek. Mumigterrlainaryuumiitaqa pilqen.",
        "translation": "Something for Caucasians to lsiten to. I don't want to keep translating what you said."
    },
    "184": {
        "startTime": 1089.905,
        "endTime": 1094.46,
        "transcript": "Yaa, tau͡gaam unuamek [?Napaskiaq].",
        "translation": "Yes, but [?Napaskiak] today."
    },
    "185": {
        "startTime": 1094.46,
        "endTime": 1100.04,
        "transcript": "[?Paskiarluteng] cakneq mingeqsartulria. Mingquk sister-aaqa-llu.",
        "translation": "They came to sew very [?]. She and my sister sewed."
    },
    "186": {
        "startTime": 1100.04,
        "endTime": 1100.61,
        "transcript": "Camek?",
        "translation": "[Sewed] what?"
    },
    "187": {
        "startTime": 1100.61,
        "endTime": 1101.96,
        "transcript": "Grant-angelpuk...",
        "translation": "The grant we received..."
    }
};